import api from 'config/Api/Api';

const baseEndpoint = 'v1/payment';

export default {
  getPayments( params ) {
    return api.get( baseEndpoint, params );
  },

  getInvoice( id ) {
    return api.get( `${baseEndpoint}/${id}/invoice` );
  },

  buyCredit( data ) {
    return api.post( `${baseEndpoint}/buy-credit`, data );
  },

  buyDdi( data ) {
    return api.post( `${baseEndpoint}/buy-ddi`, data );
  },

  updateDdiSubscription( id, data ) {
    return api.put( `${baseEndpoint}/${id}/buy-ddi`, data );
  },

  updateBuyCredit( id, data ) {
    return api.put( `${baseEndpoint}/${id}/buy-credit`, data );
  },
};
